var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0316C14.7305 10.0316 16.944 7.81805 16.944 5.08755C16.944 2.35706 14.7305 0.143555 12 0.143555C9.26953 0.143555 7.05603 2.35706 7.05603 5.08755C7.05603 7.81805 9.26953 10.0316 12 10.0316Z",
    fill: "#0E3348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5765 11.3113C6.99107 11.5259 3.46448 15.476 3.46448 20.0642V21.5014C3.46448 22.1252 3.71228 22.7235 4.15336 23.1645C4.59445 23.6056 5.19269 23.8534 5.81648 23.8534H18.1722C18.796 23.8534 19.3943 23.6056 19.8354 23.1645C20.2764 22.7235 20.5242 22.1252 20.5242 21.5014V19.8073C20.5218 18.6537 20.2853 17.5126 19.829 16.4531C19.3727 15.3936 18.7061 14.4378 17.8695 13.6434C17.0329 12.8491 16.0439 12.2329 14.9622 11.832C13.8805 11.4311 12.7286 11.254 11.5765 11.3113Z",
    fill: "#0E3348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFilled);
export default __webpack_public_path__ + "static/media/icon-user-filled.3da72eff.svg";
export { ForwardRef as ReactComponent };